import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  API_BASE_URL,
  APP_ENVIRONMENT,
  AppContext,
  authInterceptor,
  baseUrlInterceptor,
  ChunkLoadErrorHandler,
  HURO_APP_ID,
  refreshAccount
} from '@umss/shared/core';
import {
  BusinessContextService,
  BusinessTabTitleService
} from '@umss/business/data-access';
import { provideUmssIcons, UmssSplashScreenService } from '@umss/shared/ui';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    BusinessContextService,
    { provide: AppContext, useExisting: BusinessContextService },
    provideAppInitializer(() => refreshAccount()),
    provideAppInitializer(() => {
      inject(BusinessTabTitleService);
      inject(UmssSplashScreenService);
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([baseUrlInterceptor, authInterceptor])),
    provideUmssIcons(),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: APP_ENVIRONMENT, useValue: environment },
    {
      provide: HURO_APP_ID,
      useValue: 'business'
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'MM/dd/yyyy' }
    }
  ]
};
